module.exports = __webpack_public_path__ + "media/images/telescope_front-7e1c92e871e60b6c9f4cadb9e97e61d3.png";